/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_Title_AccentInputs */

const tr_landing_referral_title_accent = /** @type {(inputs: Landing_Referral_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ikiniz de kazanın`)
};

const en_landing_referral_title_accent = /** @type {(inputs: Landing_Referral_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you both win`)
};

const de_landing_referral_title_accent = /** @type {(inputs: Landing_Referral_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beide gewinnen`)
};

const ru_landing_referral_title_accent = /** @type {(inputs: Landing_Referral_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`выиграйте вдвоём`)
};

/**
* | output |
* | --- |
* | "you both win" |
*
* @param {Landing_Referral_Title_AccentInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_title_accent = /** @type {((inputs?: Landing_Referral_Title_AccentInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_Title_AccentInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_title_accent(inputs)
	if (locale === "de") return de_landing_referral_title_accent(inputs)
	if (locale === "ru") return ru_landing_referral_title_accent(inputs)
	return tr_landing_referral_title_accent(inputs)
});